/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_P2_BeforeInputs */

const es_gift_intro_p2_before = /** @type {(inputs: Gift_Intro_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válidas durante `)
};

const gl_gift_intro_p2_before = /** @type {(inputs: Gift_Intro_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válidas durante `)
};

const en_gift_intro_p2_before = /** @type {(inputs: Gift_Intro_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid for `)
};

/**
* | output |
* | --- |
* | "Valid for" |
*
* @param {Gift_Intro_P2_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_p2_before = /** @type {((inputs?: Gift_Intro_P2_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_P2_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_p2_before(inputs)
	if (locale === "en") return en_gift_intro_p2_before(inputs)
	return es_gift_intro_p2_before(inputs)
});